/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalTerms1
 */
export interface AdditionalTerms1 {
}

/**
 * Check if a given object implements the AdditionalTerms1 interface.
 */
export function instanceOfAdditionalTerms1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdditionalTerms1FromJSON(json: any): AdditionalTerms1 {
    return AdditionalTerms1FromJSONTyped(json, false);
}

export function AdditionalTerms1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalTerms1 {
    return json;
}

export function AdditionalTerms1ToJSON(value?: AdditionalTerms1 | null): any {
    return value;
}

